import {
  Autocomplete,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useEffect, useState } from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import PreviewIcon from "@mui/icons-material/Preview";
import { toast } from "react-toastify";
import { BASE_URL } from "../../global";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import { fetchAddresses } from "../invoice/productDetails";
import moment from "moment";
import { getUsers } from "../../utils/databaseHelper";
import { ClassicTable } from "../../utils/components/Styles";
import EditWrap from "../commonComponent/editWrap";
import { generatePDF1 } from "./printCheckPoints";
import InOutReadingTable from "./inOutReadingTable";

const purposeList = [
  {
    label: "Onsite",
  },
  {
    label: "self-calibration",
  },
];

const checkPointArray = [
  { label: "Service Request Form", value: false, stateKey: "serviceRequestForm", section: "JD" },
  { label: "Measurement Sheet", value: false,  stateKey: "measurementSheet", section: "JD" },
  { label: "Calibration Procedure", value: false, stateKey: "calibrationProcedure", section: "JD" },
  { label: "Calibration Sticker", value: false,  stateKey: "calibrationSticker", section: "JD" },
  { label: "Sticker Pen", value: false, stateKey: "stickerPen", section: "JD" },
  { label: "Master Instruments With Delivery Challan", value: false,  stateKey: "masterInstruments", section: "JD" },
  
  { label: "Thermohygro Meter", value: false,  stateKey: "thermohygroMeter", section: "TA" },
  { label: "Adjustable Spanner", value: false, stateKey: "adjustableSpanner", section: "TA" },
  { label: "Screw Driver Set", value: false,  stateKey: "screwDriverSet", section: "TA" },
  { label: "Cutting Pliers", value: false, stateKey: "cuttingPliers", section: "TA" },
  { label: "Teflon Tape", value: false,  stateKey: "teflonTape", section: "TA" },
  { label: "Insulation Tape", value: false, stateKey: "insulationTape", section: "TA" },
  { label: "Safety Shoe & Glouse", value: false,  stateKey: "safetyShoeGlouse", section: "TA" },
  { label: "Tissue Paper Or Soft Cloth", value: false, stateKey: "tissuePaperCloth", section: "TA" },
  { label: "IPA and Cleanining Reagents", value: false,  stateKey: "ipaCleaningReagents", section: "TA" },
  { label: "Powercord and Charger", value: false, stateKey: "powercordCharger", section: "TA" }
];


const initialColumns = [
  { id: "standardReading", label: "STANDARD READINGS", accessor: "standardReading", dataType: "text" },
  { id: "actualMeasuredReading", label: "ACTUAL MEASURED READINGS", accessor: "actualMeasuredReading", dataType: "text" },
  { id: "error", label: "ERROR", accessor: "error", dataType: "text" },
  { id: "acceptanceCriteria", label: "ACCEPTANCE CRITERIA", accessor: "acceptanceCriteria", dataType: "text" },
];

const initialData = [
  { standardReading: "", actualMeasuredReading: "", error: "", acceptanceCriteria: "" },
  { standardReading: "", actualMeasuredReading: "", error: "", acceptanceCriteria: "" },
];


export default function CreateStandardInOut() {
  const params = useParams();
  const [companyName, setCompanyName] = useState(null);
  const [clientsOption, setClientsOption] = useState([]);
  const [clientsObj, setClientsObj] = useState([]);
  const [allAddress, setAllAddress] = useState([]);
  const [loading, setLoading] = useState(false);
  const [engineers, setEngineers] = useState([]);
  const [address, setAddress] = useState("");
  const [readingRows, setReadingRows] = useState([]);
  const [editedRows, setEditedRows] = useState({});
  const [checkPointData, setCheckPointData] = useState(checkPointArray);
  
  const [standardArr, setStandardArr] = useState([]);
  const [editAccess, setEditAccess] = useState(
    localStorage.getItem("editAccess")?.split(",").map(Number)
  );
  const [standardDetails, setStandardDetails] = useState({
    purpose: "",
    outwardDate: "",
    expectedReturnDate: "",
    currentLocation: "",
    remark: "",
    srfNo: "",
    standardId: [],
    userIds: [],
  });
  const [beforeCalibrationData, setBeforeCalibrationData] = useState(
    JSON.parse(JSON.stringify(initialData))
  );
  const [afterCalibrationData, setAfterCalibrationData] = useState(
    JSON.parse(JSON.stringify(initialData))
  );
  const [deletedRowIds, setDeletedRowIds] = useState([]);

  const [letterHead, setLetterHead] = useState(true);


  var refresh = () => {
    window.location.reload(false);
  };

  const transformData = (data) => {
    return data.reduce((acc, item) => {
      const { section, stateKey, value } = item;
      if (!acc[section]) {
        acc[section] = {};
      }
      acc[section][stateKey] = value;
      return acc;
    }, {});
  };
  

  const handleChange = (index) => {
    const newData = [...checkPointData];
    newData[index].value = !newData[index].value;
    setCheckPointData(newData);
  };

  const updateSrfObject = (key, value) => {
    let newSrfObject = {
      ...standardDetails,
    };
    newSrfObject[key] = value;
    setStandardDetails(newSrfObject);
  };

  const getClientList = () => {
    let url = BASE_URL;
    axiosWithToken
      .get(url + "clients?_where=(status,eq,1)")
      .then((res) => {
        const clients = [];
        const tClientsObj = {};
        for (let i = 0; i < res.data.length; i++) {
          clients.push({
            label: res.data[i].id + ", " + res.data[i].companyName,
          });
        }
        res.data.map((e) => (tClientsObj[e.id] = e));
        setClientsObj(tClientsObj);
        setClientsOption(res.data);
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
          toast.error("Something Went Wrong!");
        }
      });
  };

  const getStandardList = () => {
    let url = BASE_URL;
    if (params.id == 0) {
      let query = {
        query: `SELECT * FROM standards s WHERE s.id = (SELECT MAX(s2.id) FROM standards s2 WHERE s2.stId = s.stId) AND s.id NOT IN (SELECT standardId FROM standardInOut WHERE standardId IS NOT NULL AND outwardDate IS NOT NULL AND (returnDate IS NULL OR returnDate >= NOW())) AND s.status = 1`,
      };
      axiosWithToken
        .post(url + `dynamic`, query)
        .then((res) => {
          const standardList = [];
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].standardName != null)
              standardList.push({
                id: res.data[i].id,
                label: res.data[i].standardName,
                stId: res.data[i].stId,
                make: res.data[i].make,
                model: res.data[i].model,
              });
          }
          setStandardArr(standardList);
        })
        .catch((error) => {
          if (error.message !== "request_aborted") {
            toast.error("Something Went Wrong!");
          }
        });
    } else {
      axiosWithToken
        .get(url + "standards?_where=(status,eq,1)")
        .then((res) => {
          const standardList = [];
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].standardName != null)
              standardList.push({
                id: res.data[i].id,
                label: res.data[i].standardName,
                stId: res.data[i].stId,
                make: res.data[i].make,
                model: res.data[i].model,
              });
          }
          setStandardArr(standardList);
        })
        .catch((error) => {
          if (error.message !== "request_aborted") {
            toast.error("Something Went Wrong!");
          }
        });
    }
  };

  const getEngineers = () => {
    getUsers(2, (res) => {
      return res.data.map((e) => {
        return { ...e, label: e.userName };
      });
    })
      .then((engineers) => {
        setEngineers(engineers);
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
          toast.error("Something Went Wrong!");
        }
      });
  };

  const submitStdInOutReadings = (stdInOutId) => {
    const url = BASE_URL;
  
    const payload = [
      ...beforeCalibrationData.map(data => ({ ...data, stdInOutId, type: 1 })),
      ...afterCalibrationData.map(data => ({ ...data, stdInOutId, type: 2 }))
    ];
  
    const updatePayload = payload.filter(data => data.id);
    const submitPayload = payload.filter(data => !data.id);
  
    const requests = [
      submitPayload.length && axiosWithToken.post(`${url}stdInOutReadings/bulk`, submitPayload),
      updatePayload.length && axiosWithToken.patch(`${url}bulk/stdInOutReadings`, updatePayload)
    ].filter(Boolean);
  
    if (requests.length) {
      Promise.all(requests)
        .then(() => {
          toast.success(`standards In/Out ${params.id ? 'updated' : 'created'} successfully!`);
          setTimeout(refresh, 500);
        })
        .catch((error) => {
          if (error.message !== 'request_aborted') toast.error('Something went wrong!');
        });
    }
  };
  

  const deleteReadings =()=>{
    let url = BASE_URL;
    let query = {
      query: `DELETE FROM stdInOutReadings WHERE id IN (${deletedRowIds.join(",")})`,
    };
    
    axiosWithToken
      .post(url + `dynamic`, query)
      .then((res) => {
       
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
          toast.error("Something Went Wrong!");
        }
      });
  }
  
  
 
  const handleSubmit = (event) => {
    let url = BASE_URL;
    const checkPointKeyAndValue = transformData(checkPointData);
    if (params.id == 0) {
      if (!companyName) {
        toast.error("Select Client!");
        return;
      }
      if (
        !standardDetails.standardId ||
        standardDetails.standardId.length === 0
      ) {
        toast.error("Select Standards!");
        return;
      }

      if (!standardDetails?.outwardDate) {
        toast.error("Select Outward Date!");
        return;
      }
      if (!standardDetails?.expectedReturnDate) {
        toast.error("Select Expected Return Date!");
        return;
      }
      if (!standardDetails.userIds || standardDetails.userIds.length === 0) {
        toast.error("Select at least one Engineer!");
        return;
      }

      const standardIds = standardDetails?.standardId
      ? standardDetails.standardId
          ?.split(",")
          ?.map((id) => parseInt(id.trim(), 10))
      : [];
    
    const payloads = standardIds.map((standardId) => ({
      clientId: companyName || null,
      address: address || null,
      purpose: standardDetails?.purpose,
      outwardDate: standardDetails?.outwardDate
        ? moment(standardDetails?.outwardDate).format("YYYY-MM-DD")
        : null,
      expectedReturnDate: standardDetails?.expectedReturnDate
        ? moment(standardDetails?.expectedReturnDate).format("YYYY-MM-DD")
        : null,
      remark: standardDetails?.remark || null,
      standardId,
      srfNo: standardDetails?.srfNo || null,
      userId: standardDetails?.userIds || null,
      jobDetails: JSON.stringify(checkPointKeyAndValue?.JD || {}),
      toolsDetails: JSON.stringify(checkPointKeyAndValue?.TA || {})
    }));
    

      axiosWithToken
        .post(url + "standardInOut/bulk", payloads)
        .then(async(res) => {
            await submitStdInOutReadings(res.data.insertId);      
        })
        .catch((error) => {
          if (error.message !== "request_aborted") {
            toast.error("Something Went Wrong!");
          }
        });
    } else {

      const payload = {
        clientId: companyName || null,
        address: address || null,
        purpose: standardDetails?.purpose,
        outwardDate: standardDetails?.outwardDate
          ? moment(standardDetails?.outwardDate).format("YYYY-MM-DD")
          : null,
        expectedReturnDate: standardDetails?.expectedReturnDate
          ? moment(standardDetails?.expectedReturnDate).format("YYYY-MM-DD")
          : null,
        remark: standardDetails?.remark || null,
        srfNo: standardDetails?.srfNo || null,
        userId: standardDetails?.userIds || null,
        jobDetails: JSON.stringify(checkPointKeyAndValue?.JD || {}),
        toolsDetails: JSON.stringify(checkPointKeyAndValue?.TA || {})
      };
      

      axiosWithToken
      .patch(url + `standardInOut/${params.id}`,payload)
      .then(async(res) => {
        await submitStdInOutReadings(params.id); 
        deletedRowIds?.length > 0 &&  await deleteReadings();
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
          toast.error("Something Went Wrong!");
        }
      });
    };
  };

  const debouncedFetchAddresses = async (addressIds, shippingAddressIds) => {
    setLoading(true);
    const newAddressArray = await fetchAddresses(
      addressIds,
      shippingAddressIds
    );
    setAllAddress(newAddressArray);
    setLoading(false);
  };

  const getStandardInOutListbyClients = () => {
    let url = BASE_URL;

    let query = {
      query: `SELECT si.*, a.address FROM standardInOut AS si LEFT JOIN addresses AS a ON a.id = SUBSTRING_INDEX(SUBSTRING_INDEX(si.address, ',', 1), ',', -1) WHERE si.clientId = ${params.id} AND si.status = 1`,
    };
    axiosWithToken
      .post(url + `dynamic`, query)
      .then((res) => {
        setReadingRows(res.data);
      })
      .catch((err) => console.log(err));
  };

  const getStandardInOutList = () => {
    let url = BASE_URL;
    let query = {
      query: `SELECT c.companyName, c.address, si.standardId,si.purpose,si.address as clientAddress, si.outwardDate, si.expectedReturnDate, si.userId, si.remark, si.srfNo, si.id AS standardInOutId, si.clientId, si.toolsDetails, si.jobDetails FROM standardInOut si JOIN clients c ON si.clientId = c.id WHERE si.id = ${params.id}`,
    };
    axiosWithToken
    .post(url + `dynamic`, query)
    .then((res) => {
      const data = res.data[0];
  
      setCompanyName(data.clientId);
      debouncedFetchAddresses(data.address, "");
      setAddress(data.clientAddress,"")
  
      setStandardDetails((prev) => ({
        ...prev,
        standardId: data.standardId,
        userIds: data.userId,
        purpose: data.purpose,
        remark: data.remark,
        srfNo: data.srfNo,
        outwardDate: moment(data.outwardDate).format("YYYY-MM-DD"),
        expectedReturnDate: moment(data.expectedReturnDate).format("YYYY-MM-DD"),
        actualStandardDate: moment(data.actualStandardDate).format("YYYY-MM-DD"),
      }));
  
      const toolsData = data.toolsDetails
        ? JSON.parse(data.toolsDetails)
        : {};
      const documentData = data.jobDetails
        ? JSON.parse(data.jobDetails)
        : {};
  
      const updatedData = checkPointData.map((item) => ({
        ...item,
        value: toolsData[item.stateKey] ?? documentData[item.stateKey] ?? item.value,
      }));
  
      setCheckPointData(updatedData);
    })
      .catch((error) => {
        if (error.message !== "request_aborted") {
          toast.error("Something Went Wrong!");
        }
      });
  };

  const getStdInOutReadings = (stdInOutId) => {
    let url = BASE_URL;
  
    let payload = {"query":`SELECT * FROM stdInOutReadings WHERE stdInOutId = ${stdInOutId}`};
  
    axiosWithToken
      .post(`${url}dynamic`, payload)
      .then((res) => {
        const beforeCalibrationData = res.data
          .filter(item => item.type === 1)
          .map(({ type, ...rest }) => rest);
        
        const afterCalibrationData = res.data
          .filter(item => item.type === 2)
          .map(({ type, ...rest }) => rest);
  
        setBeforeCalibrationData(beforeCalibrationData);
        setAfterCalibrationData(afterCalibrationData);
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
          toast.error("Something went wrong!");
        }
      });
  };

  useEffect(() => {
    getClientList();
    getEngineers();
  }, []);

  useEffect(() => {
    getStandardList();
  }, [companyName]);

  useEffect(() => {
    if (params.id != 0) {
      getStandardInOutList();
      getStandardInOutListbyClients();
      getStdInOutReadings(params.id)
    }
  }, [params.id != 0]);

  return (
    <EditWrap>
      <Typography variant="h6" component="h6" textAlign={"left"}>
        {params?.id != 0 ? "Edit" : "Create"} Master In Entry
      </Typography>
      <br />
      <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={4} lg={3}>
            <Autocomplete
              id="outlined-basic"
              label="Client"
              size="small"
              disabled={params.id != 0}
              value={clientsOption?.find((ele)=>ele.id == companyName) || null}
              options={clientsOption}
              getOptionLabel={(option) => `${option.id}, ${option.companyName}`}
              renderInput={(params) => <TextField {...params} label="Client" />}
              onChange={(event, value) => {
                if (value != null) {
                  const addressIds = value?.address;
                  const shippingAddressIds = value?.shippingAddress;
                  debouncedFetchAddresses(addressIds, shippingAddressIds);
                  setCompanyName(parseInt(value.id));
                  setAddress(clientsObj[parseInt(value.id)].address);
                } else {
                  setCompanyName(value);
                  setAddress("");
                }
              }}
            />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          {allAddress?.length === 1 ? (
            <TextField
              value={allAddress?.length === 1 ? allAddress[0]?.address : ""}
              id="outlined-basic"
              label="Address *"
              fullWidth
              variant="outlined"
              size="small"
              disabled
              onChange={(event, value) => {
                setAddress(value?.id);
              }}
            />
          ) : (
            <Autocomplete
              disabled={params.id != 0}
              options={allAddress}
              value={allAddress?.find((ele) => ele.id == address) || null}
              size="small"
              getOptionLabel={(option) => option?.address}
              renderInput={(params) => (
                <TextField {...params} label="Address *" variant="outlined" />
              )}
              onChange={(event, value) => {
                setAddress(value?.id);
              }}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Autocomplete
            multiple
            id="outlined-basic"
            size="small"
            options={standardArr}
            value={standardArr?.filter((option) =>
              option?.id == standardDetails?.standardId
            )}            
            disableCloseOnSelect
            getOptionLabel={(option) => option.label || ""}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                  checkedIcon={<CheckBoxIcon fontSize="small" />}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option.stId}: {option.label}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Master EQP"
                placeholder="select multiple Standards"
              />
            )}
            onChange={(event, value) => {
              const selectedIds = value.map((option) => option.id).join(",");
              updateSrfObject("standardId", selectedIds);
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Autocomplete
            size="small"
            id="outlined-basic"
            options={purposeList}
            label="Purpose"
            value={standardDetails?.purpose}
            renderInput={(params) => <TextField {...params} label="Purpose" />}
            // disabled
            fullWidth
            variant="outlined"
            onChange={(event, value) => {
              if (value != null) {
                updateSrfObject("purpose", value.label);
              } else {
                updateSrfObject("purpose", "");
              }
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              slotProps={{
                textField: { size: "small", fullWidth: true },
              }}
              label="Outward date"
              inputFormat="dd/MM/yyyy"
              format="dd/MM/yyyy"
              value={
                standardDetails?.outwardDate
                  ? new Date(standardDetails?.outwardDate)
                  : ""
              }
              onChange={(newValue) => {
                updateSrfObject("outwardDate", newValue);
              }}
              renderInput={(params) => (
                <TextField {...params} size="small" fullWidth />
              )}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              slotProps={{
                textField: { size: "small", fullWidth: true },
              }}
              label="Expected return date"
              inputFormat="dd/MM/yyyy"
              format="dd/MM/yyyy"
              value={
                standardDetails?.expectedReturnDate
                  ? new Date(standardDetails?.expectedReturnDate)
                  : ""
              }
              onChange={(newValue) => {
                updateSrfObject("expectedReturnDate", newValue);
              }}
              renderInput={(params) => (
                <TextField {...params} size="small" fullWidth />
              )}
            />
          </LocalizationProvider>
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Autocomplete
            id="outlined-basic"
            multiple
            options={engineers}
            size="small"
            value={engineers?.filter((option) => 
              (Array.isArray(standardDetails?.userIds) 
                ? standardDetails.userIds 
                : standardDetails?.userIds?.split(",") || []
              ).includes(option.id?.toString())
            )}
            
            disableCloseOnSelect
            renderInput={(params) => (
              <TextField {...params} label="Engineer Name" />
            )}
            // disabled
            fullWidth
            variant="outlined"
            onChange={(_, value) => {
              const engineerIds = value
                .map((engineer) => engineer.id)
                .join(",");
              updateSrfObject("userIds", engineerIds);
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <TextField
            id="outlined-basic"
            label="SRF Number"
            fullWidth
            size="small"
            value={standardDetails?.srfNo}
            variant="outlined"
            onChange={(e) => {
              updateSrfObject("srfNo", e.target.value);
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <TextField
            id="outlined-basic"
            label="Remarks"
            value={standardDetails?.remark}
            size="small"
            fullWidth
            minRows={3}
            maxRows={5}
            multiline
            variant="outlined"
            onChange={(e) => {
              updateSrfObject("remark", e.target.value);
            }}
          />
        </Grid>
      </Grid>

      <br />
      <hr />

      <Typography variant="h6" component="h6" textAlign={"center"} style={{fontSize:"18px"}}>
        CHECK LIST FOR ONSITE CALIBRATION
      </Typography>
      <br />
      <Grid container spacing={2}>
  {/* Job Detail Section */}
  <Grid item xs={12}>
    <h6 style={{fontSize:"18px", textAlign:"left", fontWeight:"bold",marginTop:"15px"}}>Job Detail</h6>
    <Grid container spacing={2}>
      {checkPointData
        .filter((item) => item.section === "JD")
        .map((item, index) => (
          <Grid item xs={4} key={item.stateKey}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Checkbox
                checked={item.value}
                onChange={() => handleChange(checkPointData.indexOf(item))}
              />
              <span>{item.label}</span>
            </div>
          </Grid>
        ))}
    </Grid>
  </Grid>

  {/* Tools/Accessories Section */}
  <Grid item xs={12}>
    <h6 style={{fontSize:"18px", textAlign:"left", fontWeight:"bold",marginTop:"15px"}}>Tools/Accessories</h6>
    <Grid container spacing={2}>
      {checkPointData
        .filter((item) => item.section === "TA")
        .map((item, index) => (
          <Grid item xs={4} key={item.stateKey}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Checkbox
                checked={item.value}
                onChange={() => handleChange(checkPointData.indexOf(item))}
              />
              <span>{item.label}</span>
            </div>
          </Grid>
        ))}
    </Grid>
  </Grid>
</Grid>
<hr />
<br />
<h6 style={{fontSize:"20px", textAlign:"center", fontWeight:"bold",marginTop:"10px"}}>Before Calibration</h6>
<InOutReadingTable
      initialColumns={initialColumns}
      data={beforeCalibrationData }
      setData={setBeforeCalibrationData }
      srNo={true}
      deletedRowIds={deletedRowIds}
      setDeletedRowIds={setDeletedRowIds}
    />


{params.id != 0 && (
  <>
  <hr />
  <br />
    <h6 style={{ fontSize: "20px", textAlign: "center", fontWeight: "bold", marginTop: "10px" }}>
      After Calibration
    </h6>
    <InOutReadingTable
      initialColumns={initialColumns}
      data={afterCalibrationData}
      setData={setAfterCalibrationData}
      srNo={true}
      deletedRowIds={deletedRowIds}
      setDeletedRowIds={setDeletedRowIds}
    />
  </>
)}



    <hr />
      <br />
      <Toolbar
        style={{
          padding: "0px",
          overflow: "auto",
          display: "flex",
          justifyContent: "flex-end",
          gap: "20px",
          marginTop: "3rem",
        }}
      >
     { params.id != 0  && (
       <>
       <Autocomplete
          size="small"
          sx={{minWidth:"200px"}}
          options={[
            { id: 1, label: "With Letter Head" },
            { id: 2, label: "Without Letter Head" },
          ]}
          renderInput={(params) => <TextField {...params} label="letterHead" />}
          onInputChange={(event, newInputValue) => {
            if (newInputValue === "With Letter Head" || newInputValue === "") {
              setLetterHead(true);
            } else if (newInputValue === "Without Letter Head") {
              setLetterHead(false);
            }
          }}
        />

       <Button
          variant="contained"
          size="small"
          onClick={() => {
            const client = clientsOption?.find(ele => ele.id == companyName);
            const addressData = allAddress?.find(ele => ele.id == address);
            const instrumentData = standardArr?.find(ele => ele.id == standardDetails?.standardId);
            generatePDF1(checkPointData, standardDetails, client, addressData,beforeCalibrationData,afterCalibrationData,instrumentData,letterHead);
          }}
          
        >
          print
        </Button>
      </>
     )}
        <Button
          variant="contained"
          style={{ backgroundColor: "grey" }}
          size="small"
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              window.history.back();
            }
          }}
        >
          Cancel
        </Button>
        <Tooltip
          title={
            !(editAccess?.includes(1) || editAccess?.includes(0))
              ? "You don't have access"
              : ""
          }
        >
          <Button
            variant="contained"
            size="small"
            sx={{ m: 0 }}
            disabled={!(editAccess?.includes(1) || editAccess?.includes(0))}
            onClick={() => {
              handleSubmit();
            }}
          >
            {params.id == 0 ? "Save" : "Update"}
          </Button>
        </Tooltip>
      </Toolbar>
    </EditWrap>
  );
}
